@switch (displayAs) {
@default {
<div class="flex flex-middle">
    <!-- select -->
    <dropdown class="m-l-1"
              (valueChange)="sortBy($event)"
              [options]="options"
              alignOptions="left"
              [hideIcon]="true">
        <ng-template #titleTpl>
            <div class="h4 col-1">
                <button class="button-3 button-size-1">{{'Sort' | translate}}</button>
            </div>
        </ng-template>
        <ng-template #optionTpl
                     let-option>
            <div class="p1 b-b b-col-42 p-t-2 p-b-2 p-l-3 p-r-3 no-wrap">{{option.label | translate}}</div>
        </ng-template>
    </dropdown>
</div>
}
@case ('buttons') {
<div class="flex p-l-2">
    <div class="w-12 flex flex-wrap m-b-4-x m-b-4-l"
         [style.gap.px]="8"
         [style.row-gap.px]="16">
        @for (option of options; track $index) {
        <button class="b-a b-col-1 p-l-3 p-r-3 p-t-1 p-b-1 p2"
                [style.border-radius.px]="24"
                [style.height.px]="32"
                (click)="sortBy(option)"
                [class.bg-col-11]="isSelected(option)"
                [class.col-w]="isSelected(option)">{{option.label | translate}}
        </button>
        }
    </div>
</div>
}
}
